<template>
    <div>
        <Header>
            <div class="buttons-right" v-if="portfolio">
                <a class="button" @click="addFeed=true" v-t="'Add Article Feed'"><span></span></a>
            </div>

        </Header>

        <div class="page" v-if="!articleFeeds||(articleFeeds)">

          <div class="alert" v-if="portfolio&&portfolio.account_type!='pro'&&portfolio.account_type!='unlimited'">
              <i class="material-icons">warning</i>
              <p>
                  <span v-t="'Your plan does not include automatic article imports.'"></span> <router-link :to="{name: 'account'}"><span v-t="'Upgrade to enable'"></span> &rarr;</router-link>
              </p>
          </div>

          <div class="block">
              <h3 class="block__heading" v-t="'Article Feed Import'"></h3>
              <p v-t="'article-feed-desc'"></p>
          </div>

            <table class="editor-table editor-table--articles">
                <thead>
                    <tr :class="{'selected-th': listManager.selectedIds.length}">
                        <th width="50px">
                            <label class="label--checkbox" v-if="articleFeeds">
                                <input type="checkbox" :checked="listManager.selectedIds.length==articleFeeds.length" @click="toggleAll()" class="checkbox">
                            </label>
                        </th>
                        <th v-show="listManager.selectedIds.length===0" v-t="'Feed URL'"></th>
                        <th v-show="listManager.selectedIds.length===0" v-t="'Blocks'"></th>
                        <th v-show="listManager.selectedIds.length===0" v-t="'Last Imported'"></th>
                        <th colspan="3" v-if="listManager.selectedIds.length!==0">
                            {{listManager.selectedIds.length}} Article Feeds Selected
                            <a @click="deleteAll()"><i class="material-icons md-light">delete</i></a>
                        </th>
                    </tr>
                </thead>
                <tbody v-if="!articleFeeds">
                    <tr>
                        <td colspan="100%">
                            <div class="loading-gif" >
                                <img :src="VUE_APP_STATIC_URL + 'img/loading.gif'">
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tbody v-if="articleFeeds">
                    <tr v-bind:key="feed.id" v-for="feed in articleFeeds" :class="{'checked': listManager.selectedIds.indexOf(feed.id) > -1}">
                        <td width="50px">
                            <label class="label--checkbox">
                                <input name="selected_articles[]" :value="feed.id" :checked="listManager.selectedIds.indexOf(feed.id) > -1" @click="toggle($event, feed)" type="checkbox" class="checkbox">
                            </label>
                        </td>
                        <td>
                            <a @click="openFeed(feed)">{{feed.url}}</a>
                        </td>
                        <td>
                            <span v-bind:key="block.id" v-for="block in feed.blocks">{{block.name}}<br></span>
                        </td>
                        <td>
                            <span v-if="!feed.last_processed">Awaiting first import... (can take up to 24 hours)</span>
                            {{feed.last_processed}}
                        </td>
                    </tr>
                    <tr v-if="articleFeeds.length==0">
                        <td colspan="100%" v-t="'No Article Feeds yet.'">
                        </td>
                    </tr>
                </tbody>
                <tfoot v-if="articleFeeds">
                    <td colspan="100%" >
                        {{articleFeeds.length}} <span v-t="'Article Feeds'"></span>
                    </td>
                </tfoot>
            </table>
        </div>

        <modal-article-feed-list-delete v-if="listManager.selectedIds" :deleteList="listManager.selectedItems" :open="modalDeleteOpen" @close="modalDeleteClose" />

        <modal-article-feed-add @close="closeRedirect" :open="addFeed"/>

        <modal-article-feed-edit @close="closeUpdate" :open="modalEditOpen" :rssFeed="modalEditFeed"/>

    </div>
</template>

<script>
    import Header from '@/components/Header.vue'
    import ModalArticleFeedAdd from '@/components/modals/ModalArticleFeedAdd.vue'
    import ModalArticleFeedEdit from '@/components/modals/ModalArticleFeedEdit.vue'
    import ModalArticleFeedListDelete from '@/components/modals/ModalArticleFeedListDelete.vue'
    import listService from '@/services/listService.js';

    export default {
        components: {
            Header,
            ModalArticleFeedAdd,
            ModalArticleFeedEdit,
            ModalArticleFeedListDelete
        },
        data () {
            return {
                VUE_APP_STATIC_URL: process.env.VUE_APP_STATIC_URL,
                modalDeleteOpen: false,
                modalEditOpen: false,
                loadingRedirects: false,
                addFeed: false,
                modalEditFeed: null,
                articleFeeds: null,
                listManager:  new listService([])
            }
        },
        computed: {
            user () {
                return this.$store.getters['auth/user']
            },
            portfolio () {
                return this.$store.getters['portfolio/portfolio']
            },
        },
        methods: {
            modalDeleteClose (feedIDs){
                this.modalDeleteOpen = false

                if(feedIDs){
                    for(var i=0;i<feedIDs.length;i++){
                        var deleteIndex = null
                        for(var j=0;j<this.articleFeeds.length;j++){
                            if(this.articleFeeds[j].id === feedIDs[i]){
                                deleteIndex = j
                            }
                        }
                        if(deleteIndex !== null){
                            this.articleFeeds.splice(deleteIndex, 1)
                        }
                    }
                }

                this.listManager = new listService(this.articleFeeds)
            },
            openFeed (feed) {
                this.modalEditOpen = true
                this.modalEditFeed = feed
            },
            closeRedirect (result){
                if (result){
                    this.articleFeeds.push(result)
                }
                this.addFeed = false
            },
            closeUpdate (result){
                if (!result){
                    this.articleFeeds.splice( this.articleFeeds.indexOf(this.modalEditFeed), 1);
                }
                this.modalEditOpen = false
                this.modalEditFeed = null
            },
            updateArticles (start_at) {
                var items = [];
                if(start_at !== 0){
                    items.push('start_at='+start_at);
                }

                this.$http.get('/redirects/?'+items.join('&')).then(data => {
                    if(start_at === 0){
                        this.articleFeeds = data.data
                        this.listManager = new listService(this.articleFeeds)
                    }else{
                        this.loadingRedirects = false
                        this.articleFeeds = this.articleFeeds.concat(data.data)
                        this.listManager = new listService(this.articleFeeds)
                    }
                })
            },
            toggle ($e, article) {
                this.listManager.toggle($e, article);
            },
            toggleAll (){
                this.listManager.toggleAll();
            },
            deleteAll () {
                this.modalDeleteOpen = true
            }
        },
        mounted () {
            this.$http.get('/rss-feeds/').then(data => {
                this.articleFeeds = data.data
                this.listManager = new listService(this.articleFeeds)
            })
        }
    }
</script>
